export function ErrorIcon() {
  return (
    <img
      src={require("../../../assets/images/error-icon.svg").default}
      alt="error"
    />
  );
}
